import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import currentDate from './helpers/current-date';
import store from './store';

const http = axios.create({
  baseURL: process.env.VUE_APP_HUB_BASE_URL
});

// Header enviado apenas nas chamadas /users; validacao no back-end fica atras
// de feature-flag, que sera ligada apos a publicacao desta versao do front.
const OP_07_HASH = '79003c6ef09e681b0961ff7e891603fbbda5f8871d0c7d31a89935866fdce07535b7717b4cbd6446a9f3c4394a3d8f86d0343712131cb7b9854a187a5ef81ed1f29a9ffc55e040c0283adeddc106896aac2bdfadde21904992c05644a2816105226b57dd5afc6b638ee6614c755c795bd6ad9cd98982e38c5b14cb6213477781';

function isUsersApiRequest(config) {
  const url = config.url || '';
  if (/^https?:\/\//i.test(url)) {
    return /\/users(\/|$|\?)/i.test(url);
  }
  return /\/users(\/|$|\?)/i.test(url) || /^users\//i.test(url);
}

http.interceptors.request.use(
  config => {
    // store.commit('formLoading', true)
    config.headers['op-version'] = config.headers['op-version'] || `C-${currentDate}-WEB`;
    if (window.$cookies.isKey('token')) {
      config.headers.Authorization = `Bearer ${window.$cookies.get('token')}`;
    }
    if (isUsersApiRequest(config)) {
      config.headers['OP-07'] = OP_07_HASH;
    }
    return config;
  },
  err => {
    store.commit('formLoading', false);
    return Promise.reject(err);
  }
);

http.interceptors.response.use(
  res => {
    const { data } = res;
    store.commit('formLoading', false);
    if (!data) return false;
    if (data.code >= 400 && data.code <= 500) {
      store.commit('message', { type: 'error', text: data.message });
    }
    return res;
  },
  err => {
    store.commit('formLoading', false);
    if (!err.response) {
      store.commit('message', {
        type: 'error',
        text:
          'Não foi possível processar a sua requisição no momento, tente novamente mais tarde.'
      });
      return Promise.reject(new Error('Verifique sua conexão.'));
    }
    if (err.response.status === 307) {
      store.commit('message', {
        type: 'error',
        text: 'Sua conta requer uma atualização de senha.'
      });
      store.commit('changePassword');
      router.push({ name: 'changePassword' });
      return Promise.reject(
        new Error('Sua conta requer uma atualização de senha.')
      );
    }
    if (err.response.status === 401 && err.response.data.error !== 'Código inválido ou já utilizado') {
      // remove cache and cookies after signout
      localStorage.clear();
      // window.$cookies.removeAll()
      store.commit('signOut');
      store.commit('message', {
        type: 'error',
        text: 'CPF/CNPJ ou Senha Inválidos.'
      });
      router.push({ name: 'signIn' });
      return Promise.reject(new Error('CPF/CNPJ ou Senha Inválidos'));
    }

    if (err.response.status === 401 && err.response.data.error === 'Código inválido ou já utilizado') {
      return Promise.reject(new Error(err.response.data.error));
    }

    if (err.response.status === 413) {
      store.commit('message', {
        type: 'error',
        text: 'O arquivo deve ter menos de 50 MB.'
      });
      return Promise.reject(new Error('PAYLOAD_TOO_LARGE'));
    }

    // check if route request is users/find-last-login
    if (err.response.config.url.indexOf('users/find-last-login') >= 0) {
      return Promise.reject(new Error(null));
    }
    if (
      typeof err.response.data.error === 'string'
      && err.response.data.error.toLowerCase().indexOf('token') >= 0
    ) {
      // remove cache and cookies after signout
      localStorage.clear();
      // window.$cookies.removeAll()
      store.commit('signOut');
      store.commit('message', {
        type: 'error',
        text: 'Sessão expirada, entre novamente.'
      });
      return Promise.reject(new Error('Sessão expirada'));
    }
    const error = err.response.data && err.response.data.error;
    let message = err.response.data || error || 'Tente novamente';
    if (typeof error === 'string') {
      message = error;
    }
    if (message && message.details && message.details[0]) {
      const msgs = [];
      message.details.map(msg => {
        return msgs.push(msg.message);
      });
      store.commit('message', { type: 'error', text: msgs.join(', ') });
    }
    if (typeof error === 'string') {
      store.commit('message', { type: 'error', text: error });
    }
    if (typeof message === 'string') {
      store.commit('message', { type: 'error', text: message });
    }
    return Promise.reject(message);
  }
);

export default http;
